import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-doctors-station-forgot-password',
  templateUrl: './doctors-station-forgot-password.component.html',
  styleUrls: [
    '../style/global.css',
    './doctors-station-forgot-password.component.css',
  ],
})
export class DoctorsStationForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}
}
